<template>
  <div id="quizcontainter">
    <ConnectionErrors />
    <div style="padding: 40px;">
        <div class="bars">
            <div v-for="(item, index) in givenAnswers" :key="index" class="bar" :class="item.Answer" :style="{height: (item.Count / gameState.TotalUsers * 370) + 30 + 'px'}">
              <span class="counter">{{ item.Count }}</span>
              <span class="bottom">{{ item.Answer }}</span>
            </div>
        </div>
        <div class="card-deck" v-if="score">
            <div class="card" v-if="score.TopTen">
                <div class="card-header">Top 10</div>
                <div class="list-group">
                    <div v-for="(item, index) in score.TopTen.$values" :key="index" class="list-group-item d-flex justify-content-between align-items-center" style="border: 0;">
                        {{ item.Description }}
                        <span class="badge badge-primary badge-pill">{{ item.Points }}</span>
                    </div>
                 </div>
            </div>
            <div class="card" v-if="score.Districts">
                <div class="card-header">Wijk totaal</div>
                <div class="list-group">
                    <div v-for="(item, index) in score.Districts.$values" :key="index" class="list-group-item d-flex justify-content-between align-items-center"  style="border: 0;">
                        {{ item.Description }}
                        <span class="badge badge-primary badge-pill">{{ item.Points }}</span>
                    </div>
                 </div>
            </div>
            <div class="card" v-if="score.Gender">
                <div class="card-header">Geslacht totaal</div>
                <div class="list-group">
                    <div v-for="(item, index) in score.Gender.$values" :key="index" class="list-group-item d-flex justify-content-between align-items-center"  style="border: 0;">
                        {{ item.Description }}
                        <span class="badge badge-primary badge-pill">{{ item.Points }}</span>
                    </div>
                 </div>
            </div>
            <div class="card" v-if="score.Ages">
                <div class="card-header">Leeftijd totaal</div>
                <div class="list-group">
                    <div v-for="(item, index) in score.Ages.$values" :key="index" class="list-group-item d-flex justify-content-between align-items-center"  style="border: 0;">
                        {{ item.Description }}
                        <span class="badge badge-primary badge-pill">{{ item.Points }}</span>
                    </div>
                 </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConnectionErrors from '@/components/ConnectionErrors.vue'

export default {
  name: 'quiz',
  computed: {
    ...mapGetters({
      isConnected: 'quiz/connected',
      gameState: 'quiz/gameState',
      score: 'quiz/scoreModel',
      givenAnswers: 'quiz/givenAnswers'
    })
  },
  components: {
    ConnectionErrors
  },
  created () {
    if (location.hash) {
      var data = {
        gameid: location.hash.substr(1)
      }
      setTimeout(() => {
        this.$store.dispatch('quiz/joinScore', data)
      }, 1000)
    }
  }
}
</script>

<style>
.bars {
    height: 400px;
    padding-bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}
.bar {
    display: flex;
    color: #fff;
    display: flex;
    width: 100px;
    margin: 0px 40px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
}
.bar span {
  font-weight: bold;
}
.bar.A {
    background-color: #007bff;
}
.bar.B {
    background-color: #28a745;
}
.bar.C {
    background-color: #dc3545;
}
.bar.D {
    background-color: #ffc107;
}
</style>
